import { getBlogAuthors } from "@/lib/api/public"
import { Blog } from "@types"
import SingleAuthorDisplay from "./SingleAuthorDisplay"
import MultipleAuthorDisplay from "./MultipleAuthorDisplay"
import { PublicUser } from "@/types/users"

export default async function Authors({ blog }: { blog: Blog }) {
  const authors = await getBlogAuthors(blog.lowercase_url)

  console.log("Authors", authors)

  return (
    <AuthorDisplay authors={authors}>
      <span className="mr-2 place-self-center flex flex-col font-body">
        Written by
      </span>
    </AuthorDisplay>
  )
}

export function AuthorDisplay({
  authors,
  children,
}: {
  authors: PublicUser[]
  children?: React.ReactNode
}) {
  if (!authors || authors.length === 0) return null

  return (
    <div className="flex items-center flex-wrap text-muted-foreground font-normal text-sm mt-2 ">
      {children}
      {authors.length === 1 ? (
        <SingleAuthorDisplay author={authors[0]} />
      ) : (
        <MultipleAuthorDisplay authors={authors} />
      )}
    </div>
  )
}
